import types from "../types";
import { copy, Notification, url_encode } from "../../utils";
import backend from "../../api";
import { global_actions } from "../";

const init_cart_from_local_storage = () => (dispatch, getState) => {
  const cart = JSON.parse(localStorage.getItem("cart")) || { items: [] };
  console.log("Initializing cart from local storage:", cart);
  dispatch({
    type: types.CART,
    payload: cart,
  });
};

const add_to_cart = ({
  product = null,
  member_user = null,
  quantity = 1,
  shared_link = null,
  book_author,
} = {}) => (dispatch, getState) => {
  const { user: user_state } = getState().auth;
  let state = copy(getState().cart);
  const status = new Notification();
  const cart_unit = { product: product._id, quantity, shared_link };
  const cart_local_unit = { product, quantity, shared_link };
  
  if (member_user) {
    cart_unit.member_user = member_user;
    cart_local_unit.member_user = member_user;
  }

  if(book_author){
    cart_unit.book_author = book_author;
    cart_local_unit.book_author = book_author;
  }

  let alreadyExistingItem = state.items
    ? state.items.find((item) => item.product._id === product._id)
    : null;
  if (alreadyExistingItem) {
    dispatch(
      update_cart_item(alreadyExistingItem, {
        quantity: alreadyExistingItem.quantity + quantity,
      })
    );
  } else {
    if (user_state) {
      dispatch(global_actions.loading(true));
      backend
        .post(`/cart/${state._id}/unit`, cart_unit, {
          params: {
            populate: url_encode([
              { path: "items", populate: [{ path: "product" }] },
            ]),
          },
        })
        .then(({ data }) => {
          state = data.data;
          status.set_toast("success", data.message);
          dispatch({
            type: types.CART,
            payload: state,
          });
          localStorage.setItem("cart", JSON.stringify(state));
        })
        .catch((error) => {
          status.set_toast(
            "error",
            error.response ? error.response.data.message : error.message
          );
        })
        .finally(() => {
          dispatch(global_actions.loading(false));
          status.show_toast();
        });
    } else {
      state = {
        items: state.items
          ? state.items.concat(cart_local_unit)
          : [cart_local_unit],
      };
      status.set_toast("success", "Item Added to Cart");
      dispatch({
        type: types.CART,
        payload: state,
      });
      localStorage.setItem("cart", JSON.stringify(state));
      status.show_toast();
    }
  }
};




/**
 * TODO: Integrate with backend
 */
const update_cart_item = (unit = null, update = {}) => (dispatch, getState) => {
  const { user: user_state } = getState().auth;
  let state = copy(getState().cart);
  const status = new Notification();
  if (user_state) {
    dispatch(global_actions.loading(true));
    backend
      .put(`/cart/${state._id}/unit/${unit._id}`, update, {
        params: {
          populate: url_encode([
            { path: "items", populate: [{ path: "product" }] },
          ]),
        },
      })
      .then(({ data }) => {
        state = data.data;
        status.set_toast("success", data.message);
      })
      .catch((error) => {
        status.set_toast(
          "error",
          error.response ? error.response.data.message : error.message
        );
      })
      .finally(() => {
        dispatch({
          type: types.CART,
          payload: state,
        });
        dispatch(global_actions.loading(false));
        status.show_toast();
      });
  } else {
    state = {
      items: state.items.map((c) => {
        if (c.product._id !== unit.product._id) {
          return c;
        } else {
          return { ...c, ...update };
        }
      }),
    };
    status.set_toast("info", "Item Updated in Cart");
    dispatch({
      type: types.CART,
      payload: state,
    });
    localStorage.setItem("cart", JSON.stringify(state));
    status.show_toast();
  }
};

const remove_from_cart = ({ unit = null } = {}) => (dispatch, getState) => {
  const { user: user_state } = getState().auth;
  let state = copy(getState().cart);
  const status = new Notification();
  if (user_state) {
    dispatch(global_actions.loading(true));
    backend
      .delete(`/cart/${state._id}/unit/${unit._id}`, {
        params: {
          populate: url_encode([
            { path: "items", populate: [{ path: "product" }] },
          ]),
        },
      })
      .then(({ data }) => {
        state.items = state.items.filter(
          (c) => c.product._id !== unit.product._id
        );
        status.set_toast("success", data.message);
      })
      .catch((error) => {
        status.set_toast(
          "error",
          error.response ? error.response.data.message : error.message
        );
      })
      .finally(() => {
        dispatch({
          type: types.CART,
          payload: state,
        });
        dispatch(global_actions.loading(false));
        status.show_toast();
      });
  } else {
    state = {
      items: state.items.filter((c) => c.product._id !== unit.product._id),
    };
    status.set_toast("warn", "Item Removed from Cart");
    dispatch({
      type: types.CART,
      payload: state,
    });
    localStorage.setItem("cart", JSON.stringify(state));
    status.show_toast();
  }
};

const move_from_wishlist_to_cart = ({ unit = null } = {}) => (
  dispatch,
  getState
) => {
  const { user: user_state } = getState().auth;
  let cart_state = copy(getState().cart);
  let wishlist_state = copy(getState().wishlist_);
  const status = new Notification();
  if (user_state) {
    dispatch(global_actions.loading(true));
    backend
      .delete(`/favorite/${wishlist_state._id}/unit/${unit._id}`, {
        params: {
          populate: url_encode([
            { path: "items", populate: [{ path: "product" }] },
          ]),
        },
      })
      .then(({ data }) => {
        wishlist_state = data.data;
        status.set_toast("info", data.message);
        status.show_toast();
        return backend.post(
          `/cart/${cart_state._id}/unit`,
          { product: unit.product._id, quantity: unit.quantity },
          {
            params: {
              populate: url_encode([
                { path: "items", populate: [{ path: "product" }] },
              ]),
            },
          }
        );
      })
      .then(({ data }) => {
        cart_state = data.data;
        status.set_toast("info", data.message);
        status.show_toast();
      })
      .catch((error) => {
        status.set_toast(
          "error",
          error.response ? error.response.data.message : error.message
        );
        status.show_toast();
      })
      .finally(() => {
        dispatch({
          type: types.CART,
          payload: cart_state,
        });
        dispatch({
          type: types.WISHLIST,
          payload: wishlist_state,
        });
        dispatch(global_actions.loading(false));
      });
  } else {
    cart_state = {
      items:
        cart_state.items && cart_state.items.length > 0
          ? cart_state.items.concat([unit])
          : [unit],
    };
    wishlist_state = {
      items:
        wishlist_state.items && wishlist_state.items.length > 0
          ? wishlist_state.items.filter(
              (w) => w.product._id !== unit.product._id
            )
          : [],
    };
    status.set_toast("success", "Item Transferred to Cart");
    dispatch({
      type: types.CART,
      payload: cart_state,
    });
    dispatch({
      type: types.WISHLIST,
      payload: wishlist_state,
    });
    localStorage.setItem("wishlist", JSON.stringify(wishlist_state));
    localStorage.setItem("cart", JSON.stringify(cart_state));
    status.show_toast();
  }
};

export default {
  init_cart_from_local_storage,
  add_to_cart,
  remove_from_cart,
  move_from_wishlist_to_cart,
  update_cart_item,
};
